import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children", "className", "color", "icon", "tag"];
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var O2ModalFooterButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(O2ModalFooterButton, _React$PureComponent);

  function O2ModalFooterButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    });

    return _this;
  }

  var _proto = O2ModalFooterButton.prototype;

  _proto.textContent = function textContent(text) {
    return /*#__PURE__*/React.createElement("span", {
      className: "o2-modal__footer-btn-text"
    }, text);
  };

  _proto.iconContent = function iconContent(icon) {
    return /*#__PURE__*/React.createElement("span", {
      className: "o2-icon o2-icon--" + icon
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        color = _this$props.color,
        icon = _this$props.icon,
        Tag = _this$props.tag,
        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var classes = classNames(className, "o2-modal__footer-btn", color ? "o2-modal__footer-btn--" + color : false);

    if (attributes.href && Tag === "button") {
      Tag = "a";
    }

    var content;

    if (icon && children) {
      content = /*#__PURE__*/React.createElement(React.Fragment, null, this.iconContent(icon), this.textContent(children));
    } else if (icon) {
      content = this.iconContent(icon);
    } else if (typeof children === "string") {
      content = this.textContent(children);
    } else {
      content = children;
    }

    return /*#__PURE__*/React.createElement(Tag, _extends({
      type: Tag === "button" && attributes.onClick ? "button" : undefined
    }, attributes, {
      className: classes,
      onClick: this.onClick
    }), content);
  };

  return O2ModalFooterButton;
}(React.PureComponent);

O2ModalFooterButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.string,
  color: PropTypes.oneOf(["success", "warning", "danger", "neutral"]),
  onClick: PropTypes.func,
  icon: PropTypes.string
};
O2ModalFooterButton.defaultProps = {
  tag: "button"
};
export default O2ModalFooterButton;